import { SignatureScopeFilter } from '../../../enums/signature-scope.const';
import { allSignaturesColumnsConfig } from './all-signatures-columns.config';
import { mySignaturesColumnsConfig } from './my-signatures-columns.config';

export type SignaturesTableColumnsConfig = typeof allSignaturesColumnsConfig;

export const scopeToColumnsConfig: Record<SignatureScopeFilter, SignaturesTableColumnsConfig> = {
  [SignatureScopeFilter.ALL]: allSignaturesColumnsConfig,
  [SignatureScopeFilter.MY_SIGNATURES]: mySignaturesColumnsConfig,
};
